// extracted by mini-css-extract-plugin
export default {"toast-list":"ToastProvider_toast-list__UjC1N"};